export const FEATURES = [
  'super_user',
  'registration_preview',
  'dropin_attendance',
  'tournaments',
  'events',
  'event_forms',
  'clinic_applications',
  'team_review',
] as const;

export type Feature = (typeof FEATURES)[number];

export const STAFF_FEATURES: readonly Feature[] = [
  'super_user',
  'dropin_attendance',
  'event_forms',
  'team_review',
];
export const FEATURE_ACCESS = [
  'disabled',
  'selected_members',
  'everyone',
] as const;
export type FeatureAccess = (typeof FEATURE_ACCESS)[number];
export type FeatureFlags = Partial<
  Record<
    Feature,
    {
      access: FeatureAccess;
      members: readonly string[];
    }
  >
>;

export function hasFeatureFlag(
  name: Feature,
  member: string,
  flags: FeatureFlags,
): boolean {
  const flag = flags[name];
  return (
    flag?.access === 'everyone' ||
    (flag?.access === 'selected_members' && flag.members.includes(member))
  );
}
